import { createSlice } from '@reduxjs/toolkit';

const studentNames = createSlice({
  name: 'studentNames',
  initialState: {
    studentNamesArr: '',
    subjectsStudentObj: {},
  },
  reducers: {
    setStudentNames(state, action) {
      state.studentNamesArr = action.payload;
    },
    setSubjectsStudent(state, action) {
      state.subjectsStudentObj = action.payload;
    },
  },
});

export const { setStudentNames, setSubjectsStudent } = studentNames.actions;

export const getStudentNames = state => state.studentNames.studentNamesArr;
export const getSubjectsStudent = state => state.studentNames.subjectsStudentObj;

export default studentNames.reducer;
